export default {
  updateForms (state, payload) {
    state.forms = {
      ...state.forms,
      ...payload
    }
  },
  deleteForm (state, id) {
    // Due to a limitation in JS/Vue in order to have a reactive
    // render, using this workaround rather than actually deleting the property
    state.forms[id].deleted = true
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tools/forms/mutations.js